import { merge } from 'lodash';

const initialState = {
  /* Campos etapa 1 */
  titulo: '',
  obraMaterialList: [
    { text: 'SIM', value: true },
    { text: 'NÃO', value: false }
  ],
  possuiObra: false,
  possuiMaterial: false,
  depreciaMes: false,
  vlrAlmoxarifado: 0.0,
  aisDataBase: null,
  origemDadosAis: 'AIS',
  dataSimulacaoLaudo: null,
  dataImobilizacaoInicio: null,
  dataImobilizacaoFim: null,
  arquivoBaseContabil: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '"',
    uploading: false
  },
  arquivoRosVal: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '"',
    uploading: false
  },
  arquivoIa: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '"',
    uploading: false
  },
  arquivoObrigacoesEspeciais: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '"',
    uploading: false
  },
  /* Campos etapa 2 */
  origemDadosBancoPrecosList: [
    { text: 'CÁLCULO', value: 'CALCULO' },
    { text: 'CSV', value: 'CSV' }
  ],
  origemDadosBancoPrecos: 'CALCULO',
  bancoPrecos: {
    id: null,
    nome: ''
  },
  bancoPrecosMateriais: false,
  bancoPrecosTucagens: false,
  infoUploadedFileMaterial: {
    id: null,
    delimitador: null,
    involucro: null,
    escape: null,
    mapeamento: {
      CODIGO_MATERIAL: '',
      VALOR_UNITARIO: ''
    },
    camposObrigatorios: ['CODIGO_MATERIAL', 'VALOR_UNITARIO'],
    needToUploadFakeFile: false
  },
  infoUploadedFileTucagem: {
    id: null,
    delimitador: null,
    involucro: null,
    escape: null,
    mapeamento: {
      TUC: '',
      A1: '',
      A2: '',
      A3: '',
      A4: '',
      A5: '',
      A6: '',
      VALOR_UNITARIO: ''
    },
    camposObrigatorios: ['TUC', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'VALOR_UNITARIO'],
    needToUploadFakeFile: false
  },
  /* Campos etapa 3 */
  saneamentoVoc: {
    nome_calculo: null,
    saneamento_voc_id: null
  },
  desconsiderarExcecoes: {
    incorporacao: false,
    doacao: false,
    tipologias: false,
    servidao: false,
    estacao_movel: false,
    terreno: false
  },
  percentuais: {
    /* tipoTipologia = ('Informar percentual' || 'Saneamento do VOC') */
    RAU: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    RAR: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    RDS: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    SDU: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    SDR: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    SMU: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    SMR: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    LAR: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    LAU: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' },
    LARS: { perc_fator_saneamento: '100', tipoTipologia: 'Informar percentual' }
  },
  arquivoPercSaneamentoObra: {
    id: '',
    fileObj: undefined,
    nome: '',
    delimitador: ';',
    involucro: '"',
    escape: '"',
    cabecalho: ['COD_OBRA', '%_SANEAMENTO_VOC', '%_SANEAMENTO_COM', '%_SANEAMENTO_CA'],
    uploading: false
  }
};

const state = initialState;

const getters = {};

const actions = {
  setSimulacaoLaudoIncremental({ commit }, value) {
    commit('SET_SIMULACAO_LAUDO_INCREMENTAL', value);
  },
  clearSimulacaoLaudoIncremental({ commit }) {
    commit('CLEAR_SIMULACAO_LAUDO_INCREMENTAL', initialState);
  }
};

const mutations = {
  SET_SIMULACAO_LAUDO_INCREMENTAL: (state, value) => (state = merge(state, value)),
  CLEAR_SIMULACAO_LAUDO_INCREMENTAL: (state, value) => {
    state = merge(state, value);
    state.arquivoBaseContabil.fileObj = undefined;
    state.arquivoRosVal.fileObj = undefined;
    state.arquivoIa.fileObj = undefined;
    state.arquivoObrigacoesEspeciais.fileObj = undefined;
    state.arquivoPercSaneamentoObra.fileObj = undefined;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
